/**
 * The SHA-256 of the exact probe bytes, as the enrol capture sends it (slice 04). The server
 * hashes the same bytes on the check and returns `probe_sha256`, which stands in where the
 * browser has no `crypto.subtle` (a phone on plain HTTP is not a secure context).
 */

/** Hex SHA-256 of a blob, or null where `crypto.subtle` is missing (not a secure context). */
export async function sha256Hex(blob: Blob): Promise<string | null> {
  const subtle = globalThis.crypto?.subtle
  if (!subtle) return null
  const digest = await subtle.digest('SHA-256', await blob.arrayBuffer())
  return Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, '0')).join('')
}
